module.exports = __webpack_public_path__ + "img/image_service_7.976444ae.png";